import { Badge } from '@lectura/ui';
import type { Publication, RecentPublication } from '@lectura/ts-contracts';
import type { Route } from 'next';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

const ALLAPOT_CIMKE: Record<Publication['status'], { label: string; variant: 'success' | 'warning' | 'neutral' | 'danger' }> = {
  draft: { label: 'piszkozat', variant: 'neutral' },
  review: { label: 'ellenőrzés', variant: 'warning' },
  published: { label: 'publikálva', variant: 'success' },
  retired: { label: 'archivált', variant: 'danger' },
};

/**
 * Rövid lista a legutóbb módosított publikációkról, a dashboard jobb oszlopában.
 * Klikkelhető — a /publications/[id] részletoldalra navigál (azt később építjük).
 */
export function RecentPublicationsList({ items }: { items: RecentPublication[] }) {
  if (items.length === 0) {
    return (
      <p className="py-6 text-center text-sm text-[var(--color-foreground-muted)]">
        Még nincs publikáció.
      </p>
    );
  }

  return (
    <ul className="space-y-2">
      {items.map((p) => {
        const meta = ALLAPOT_CIMKE[p.status];
        return (
          <li key={p.id}>
            <Link
              href={`/publications/${p.id}` as Route}
              className="group flex items-center gap-3 rounded-xl px-2 py-2 transition-colors hover:bg-[var(--color-surface-muted)]"
            >
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium">{p.title}</p>
                <p className="text-xs text-[var(--color-foreground-muted)]">
                  Frissítve: {new Date(p.updatedAt).toLocaleDateString('hu-HU')}
                </p>
              </div>
              <Badge variant={meta.variant}>{meta.label}</Badge>
              <ChevronRight className="size-4 shrink-0 text-[var(--color-foreground-subtle)] transition-colors group-hover:text-brand-600" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
